import { render, staticRenderFns } from "./delmodal.vue?vue&type=template&id=b2ac6358&scoped=true&"
import script from "./delmodal.vue?vue&type=script&lang=js&"
export * from "./delmodal.vue?vue&type=script&lang=js&"
import style0 from "./delmodal.vue?vue&type=style&index=0&id=b2ac6358&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ac6358",
  null
  
)

export default component.exports